import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh_tw from "./zh_TW"
import zh_cn from "./zh_CN"
import en from "./en"
import ko from "./ko"
import ja from "./ja"
import {AVAILABLE_LOCALES, LOCALE_KEY} from '../utils/constants'

Vue.use(VueI18n)

const FALLBACK_LANG = 'en'
const preset_lang = window.localStorage.getItem(LOCALE_KEY) ? window.localStorage.getItem(LOCALE_KEY) : FALLBACK_LANG

const locale_messages = {
    'zh-tw': zh_tw,
    'zh-cn': zh_cn,
    'en': en,
    'ja': ja,
    'ko': ko
}

const i18n = new VueI18n({
    locale: preset_lang,
    messages: locale_messages,
})
export const getMostFitLocale = (lang) =>{
    return AVAILABLE_LOCALES.find( _locale=> (lang===_locale) || 
            (lang.substring(0,2)===_locale.substring(0,2) && lang.substring(2,3)==='-') ||
            (_locale.substring(0,2)===lang)) || FALLBACK_LANG   
}

export const setUp = (lang) => {
    let detected_lang = FALLBACK_LANG

    if (lang === undefined) {
        const preset_lang = window.localStorage.getItem(LOCALE_KEY) || ''
        detected_lang = getMostFitLocale(preset_lang)
    }else{
        // check if lang exists in available locales
        detected_lang = getMostFitLocale(lang) 
    }

    window.localStorage.setItem(LOCALE_KEY, detected_lang) 
    
    AVAILABLE_LOCALES.forEach(_lang => {
        document.body.classList.remove(`lang-${_lang}`)
    })
    document.body.classList.add(`lang-${detected_lang}`)
    document.body.setAttribute('lang', detected_lang)
    // Vue.config.lang = lang
    // i18n.locale = lang
}

//setUp()
window.i18n = i18n
export default i18n